import axios from 'axios';

export default {
  getMonitoring(params = {}) {
    return axios.get('/v1/purchasing-orders', { params });
  },
  getNonPO(params = {}) {
    return axios.get('/v1/non-purchasing-orders', { params });
  },
  getHistoryLog(params = {}) {
    return axios.get('/v1/logs/purchasing-orders', { params });
  },
  getDetailHistory(id) {
    return axios.get(`/v1/logs/purchasing-orders/${id}`);
  },
  completePO({ id }) {
    return axios.patch(`/v1/purchasing-orders/complete/${id}`);
  },
  uncompletePO({ id }) {
    return axios.patch(`/v1/purchasing-orders/uncomplete/${id}`);
  },
  uploadPoComplete(data) {
    return axios.patch('/v1/purchasing-orders/upload/complete', data);
  },
  getFilteredPO(params = {}) {
    return axios.get('/v1/purchasing-orders/column/list-filter', { params });
  },
  getFilteredNonPO(params = {}) {
    return axios.get('/v1/non-purchasing-orders/column/list-filter', {
      params
    });
  }
};
